import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Protocol({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M2 3.99935H10.6667" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M12.6663 6.66634H8.66634C7.92967 6.66634 7.33301 6.06967 7.33301 5.33301V2.66634C7.33301 1.92967 7.92967 1.33301 8.66634 1.33301H12.6663C13.403 1.33301 13.9997 1.92967 13.9997 2.66634V5.33301C13.9997 6.06967 13.403 6.66634 12.6663 6.66634Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" d="M13.9997 11.9993H5.33301" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" d="M12.667 13.3327L14.0003 11.9993L12.667 10.666" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M3.33333 9.33301H7.33333C8.07 9.33301 8.66667 9.92967 8.66667 10.6663V13.333C8.66667 14.0697 8.07 14.6663 7.33333 14.6663H3.33333C2.59667 14.6663 2 14.0697 2 13.333V10.6663C2 9.92967 2.59667 9.33301 3.33333 9.33301Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" d="M3.33333 2.66602L2 3.99935L3.33333 5.33268" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Protocol;